import { set, when } from 'cerebral/operators'

import getUnapprovedUsers from '../actions/getUnapprovedUsers.js'
import loadClient from '../actions/loadClient'
import setClient from '../actions/setClient.js'
import setFavicon from '../actions/setFavicon'
import setFetchOptions from '../actions/setFetchOptions.js'
import setSearchOptions from '../actions/setSearchOptions.js'
import setTitle from '../actions/setTitle'
import setUnapprovedUsers from '../actions/setUnapprovedUsers.js'
import setUserFormSaving from '../actions/setUserFormSaving.js'
import isLoggedIn from '../actions/isLoggedIn.js'
import initializeFields from './initializeFields'
import isPreventAllClientFields from '../../user/factories/isPreventAllClientFields'
import setAdminClientHelperForLoggedInUser from '../../user/actions/setAdminClientHelperForLoggedInUser'
import resetAllForms from '../../user/factories/resetAllForms'
import parseBusLocale from '../actions/parseBusLocale'
import parseRedirectAfterGDPRCookie from '../actions/parseRedirectAfterGDPRCookie'
import setAgreeDBPRTerms from '../actions/setAgreeDBPRTerms'
import loadTranslations from '../actions/loadTranslations'
import filterByKeyLookup from '../actions/filterByKeyLookup'
import onSSOErrors from './onSSOErrors'

export default [
  ...onSSOErrors,
  loadClient,
  {
    success: [
      setClient,
      parseBusLocale,
      parseRedirectAfterGDPRCookie,
      setUserFormSaving,
      setTitle,
      setFavicon,
      ...initializeFields,
      isLoggedIn,
      {
        true: [
          setAgreeDBPRTerms,
          setAdminClientHelperForLoggedInUser,
          getUnapprovedUsers,
          {
            success: [filterByKeyLookup, setUnapprovedUsers]
          },
        ],
        false: [
          function redirectSSOLogins({ input, output }){
            if(input.result.client.sso){
              window.location.href = input.result.client.sso.thirdPartyLoginURL
              return output({ redirect: true })
            }
          },
          isPreventAllClientFields(true),
          resetAllForms()
        ]
      },
      loadTranslations,
      {
        true: [],
        false: []
      },
      setFetchOptions,
      setSearchOptions
    ],
    error: []
  },
  when('input:redirect'), {
    true: [],
    false: [set('state:app.loaded', true)]
  }
]



// WEBPACK FOOTER //
// ./src/modules/app/chains/appMounted.js